import { SETTINGS_SECTION_IDS, SettingsSection } from '../types/types';

export const SETTINGS_SECTIONS: SettingsSection[] = [
  {
    id: SETTINGS_SECTION_IDS.ACCOUNT,
    label: 'Account',
    labelTranslationKey: 'account_settings',
    sectionHeading: 'Account',
    modalTitleKey: 'account_settings',
    modalTitleId: 'account-settings-modal',
  },
  {
    id: SETTINGS_SECTION_IDS.NOTIFICATIONS,
    label: 'Notifications',
    labelTranslationKey: 'notification_preferences',
    sectionHeading: 'Notifications Preferences',
    modalTitleKey: 'notifications_preferences',
    modalTitleId: 'notifications-modal',
  },
  {
    id: SETTINGS_SECTION_IDS.STEPS,
    label: 'Step Count',
    labelTranslationKey: 'step_count',
    sectionHeading: 'Step Count',
    modalTitleKey: 'step_count_settings',
    modalTitleId: 'step-count-modal',
  },
  {
    id: SETTINGS_SECTION_IDS.SECURITY,
    label: 'Security Settings',
    labelTranslationKey: 'security_settings_title',
    sectionHeading: 'Security Settings',
    modalTitleKey: 'security_settings',
    modalTitleId: 'security-settings-modal',
  },
  {
    id: SETTINGS_SECTION_IDS.SUPPORT,
    label: 'Support and Feedback',
    labelTranslationKey: 'support_and_feedback',
    sectionHeading: 'Support and Feedback',
    modalTitleKey: 'support_and_feedback',
    modalTitleId: 'support-feedback-modal',
  },
  {
    id: SETTINGS_SECTION_IDS.TERMS,
    label: 'Terms and Agreements',
    labelTranslationKey: 'terms_and_agreements',
    sectionHeading: 'Terms and Agreements',
    modalTitleKey: 'terms_and_agreements',
    modalTitleId: 'terms-agreements-modal',
  },
];
